import './goals';
import './hours';
import './messages';
import './operators';
import './payments';
import './profile';
import './util';

import './shop.service.js';
import './_shop.styles.scss';

angular
.module('inkfinder')
.config(function($stateProvider, USER_ROLES) {
  $stateProvider
  // Shop profile base
  .state('inkfinder.shop', {
    url: '/shop',
    abstract: true,
    views: {
      '@': {
        template: require('./base.template.html')
      }
    },
    data: {
      authorizedRoles: [USER_ROLES.operator]
    }
  });
});



// WEBPACK FOOTER //
// ./components/shop/index.js